import $ from 'zepto';
import { onDocumentReady } from '../../main';

import { ESC_KEYCODE } from '../../utils/constants/keys';
import { stopPropagation } from '../../utils';
import { getHeaderClasses } from '../../utils/constants/classes';
import { hideAll } from '../legacy/tooltips';

const $window = $(window);
const $html = $(document.documentElement);

export default class Header {
  constructor(prefix) {
    Object.assign(this, getHeaderClasses(prefix));

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onClickIcon = this.onClickIcon.bind(this);
    this.onClickMenuItem = this.onClickMenuItem.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
  }

  /**
   * Initialize header
   *
   * @returns {Header}
   */
  initHeader() {
    this.$menuContainer = $(`.${this.menuContainerClass}`);
    this.$menuIcon = $(`.${this.menuIconClass}`);
    this.$subMenu = $(`.${this.menuSubClass}`);
    this.$headerMenuBorder = $(`.${this.headerMenuBorderClass}`);
    this.$mainMenu = $(`.${this.menuContainerClass} > .${this.menuUlClass}`);
    this.$header = $(`.${this.headerClass}`);
    this.$menuAction = $(`.${this.menuAction}`);

    $window.on('keydown', this.onKeyDown);
    $window.on('resize', this.onResize);

    // Stop propagation for submenu achor items
    $(`.${this.menuItemAnchorClass}`).on('click', stopPropagation);

    // Toggle classes to elements when click on hamburger icon
    $(`.${this.menuActionClass}, .${this.menuContainerClass}`).on('click', this.onClickIcon);

    // Add/remove active class on submenu parent element
    $(`.${this.menuSubClass} > .${this.menuItemAnchorClass}`).on('click', this.onClickMenuItem);

    $html.on('focusin', this.onFocusIn);

    return this;
  }

  // #region actions
  /**
   * gives specific height to the menu container and menu
   *
   * @returns {Header}
   */
  setMenuHeight() {
    const headerTopDistance = this.$header.get(0) ? this.$header.get(0).offsetTop : 0;
    const menuHeight = $html.height() - (this.$header.height() + headerTopDistance);

    // Adding height to menu container based on body height to show the
    // black layer behind the menu dropdown section.
    this.$menuContainer.css({ height: menuHeight });
    this.$mainMenu.css('max-height', `${menuHeight}px`);

    return this;
  }

  /**
   * Toggle classes to menu elements
   *
   * @returns {Header}
   */
  toggleMenu() {
    this.setMenuHeight();

    // Add/remove class to HTML tag to remove the scroll behaviour while dropdown
    // menu is open
    $html.toggleClass(this.overflowHiddenFixedClass);
    this.$menuAction.attr('aria-expanded', false);
    // Add/remove classes to open and close menu
    this.$menuIcon.toggleClass(this.menuIconActiveClass);
    this.$headerMenuBorder.toggleClass(this.headerMenuBorderOpenClass);
    this.$menuContainer.toggleClass(this.menuContainerExpandedClass);

    if (this.$menuIcon.hasClass(this.menuIconActiveClass)) {
      this.$subMenu.removeClass(this.menuItemAnchorActiveClass);
      this.$menuAction.attr('aria-expanded', true);
    }

    // Close country picker popover components
    // to fix overlay elements when show mobile menu
    hideAll();

    return this;
  }

  /**
   * Gives active class to xvxMenuSub element
   *
   * @param {Zepto} $menuItem menu item to activate
   * @returns {Header}
   */
  setActiveMenuItem($menuItem) {
    const $anchor = $menuItem.children('a');
    if ($menuItem.hasClass(this.menuItemAnchorActiveClass)) {
      this.$subMenu.removeClass(this.menuItemAnchorActiveClass);
      $anchor.attr('aria-expanded', false);
    } else {
      this.$subMenu.removeClass(this.menuItemAnchorActiveClass);
      $menuItem.addClass(this.menuItemAnchorActiveClass);
      $anchor.attr('aria-expanded', true);
    }
    return this;
  }

  // #region event handlers
  onResize() {
    this.setMenuHeight();
  }

  onKeyDown(evt) {
    if (evt.keyCode === ESC_KEYCODE && $html.hasClass(this.overflowHiddenFixedClass)) {
      this.toggleMenu();
    }
  }

  onClickIcon(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.toggleMenu();
  }

  onClickMenuItem(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    this.setActiveMenuItem($(evt.target).parent());
  }

  onFocusIn(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    if (this.$menuAction.attr('aria-expanded') === 'true') {
      if (this.$menuContainer.has(document.activeElement).length === 0) {
        this.toggleMenu();
      }
    }
  }
}

onDocumentReady('Header', () => {
  new Header('xvx-').initHeader();
  new Header('xppvx_').initHeader();
});
